import { queryCountries, queryProvinces, queryCities } from '@/api/global'
import { getuserInfo } from "@/api/account";
import { getCustomer } from "@/api/webKefu";
import {MessageBox} from "element-ui";
import router from '@/router';
import i18n from '@/i18n';

const state = {
    countries: [],
    provinces: [],
    cities: [],
    YHMoney:{},
    comment_tag_en:['well-mannered','be conscientious and responsible','Strong sense of responsibility','Standard operation','Technical specialty','efficient','careful','Strong communication skills'],
    comment_tag:['态度好','尽职尽责','责任心强','规范操作','技术专业','效率高','细心','沟通能力强'],
    userInfo:JSON.parse(localStorage.getItem('userInfo'))?JSON.parse(localStorage.getItem('userInfo')):{},
    showPlay: false, //聊天弹出框
    GroupList:[],
    sendMsgType:0,
    KefuInfo:{},
    age:"20",
    chatParams:{a:111}
}

const mutations = {
    SET_CHAT_PARAMS(state, obj) {
        state.chatParams = obj;
    },
    SET_SEND_MSGTYPE(state,val){
        state.sendMsgType = val
    },
    SET_CHAT_GroupList(state,val){
        state.GroupList = val
    },
    SET_CHAT_STATUS(state, val) {
        // console.log(state)
        state.showPlay = val
    },
    SET_COUNTRIES(state, payload) {
        state.countries = payload
    },
    SET_PROVINCE(state, province) {
        state.provinces = province;
    },
    SET_CITYS(state, city) {
        state.cities = city
    },
    SET_YHMONEY(state,obj){
        state.YHMoney = obj
    },
    set_userInfo(state,obj){
        state.userInfo = obj
    },
    set_KEFUInfo(state,obj){
        state.KefuInfo = obj
    }
}

const actions = {
    // 国家
    async fetchCountries({ commit }) {
        // if(!payload) payload = localStorage.getItem('locale') == 'zh' ? 1 : 2
        const res = await queryCountries()
        const { code, data } = res.data;
        if (code == 200) {
            commit('SET_COUNTRIES', data);
        }
    },

    // 省市区
    async fetchProvince({ commit }) {
        const res = await queryProvinces();
        const { code, data } = res.data;
        if(code == 200) {
            commit('SET_PROVINCE', data)
        }
    },

    async fetchCities({ commit }) {
        const res = await queryCities();
        const { code, data } = res.data;
        if(code == 200) {
            commit('SET_CITYS', data)
        }
    },
    // 获取客服信息
    async getCustomer({ commit }) {
        if(!this.state.KefuInfo){
            const res = await getCustomer();
            const { code, data } = res.data;
            if (code == 200) {
            commit('set_KEFUInfo',data)
            }
        }
    },
    // 获取用户信息
    async getUserinfo({ commit }) {
        const res = await getuserInfo();
        const { code, data } = res.data;
        if (code == 200) {
            let result = data.data
            if (localStorage.getItem('locale') != 'zh') {
                result.country = result.country_en
            }
            // console.log('set_store_uinfo', result);
            let adminHandle = localStorage.getItem('handle')
            let uinfo_check = result.uinfo_check
            //  客服登录跳过检查
            if(uinfo_check.err && !adminHandle){
                // 检查地址
                if((uinfo_check.type=='user'&&router.currentRoute.path.indexOf('/user/accountManage')===-1)
                    || (uinfo_check.type=='insp'&&router.currentRoute.path.indexOf('/insp/accountManage')===-1)){
                    let ssn_check_time = localStorage.getItem('ssn_check_time')
                    if(ssn_check_time) ssn_check_time = parseInt(ssn_check_time)
                    let current_ts = new Date().getTime()

                    // if(ssn_check_time + 300000 < current_ts){
                        localStorage.setItem('ssn_check_time', current_ts)
                        MessageBox.confirm(uinfo_check.err, i18n.t('Notice'), {
                            confirmButtonText: i18n.t('fill_in'),
                            cancelButtonText: i18n.t('pay_qx'),
                            type: 'warning'
                        }).then(() => {
                            router.push(uinfo_check.url)
                            // router.push({ path: '/insp/accountManage', query: { tab: 1 } })
                        }).catch(() => {});;
                    // }
                }
            }

            localStorage.setItem('userInfo', JSON.stringify(result))
            localStorage.setItem("role", result.role);
            commit('set_userInfo', result)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}